import {
    IDMEUSERDATA_LOADING, GET_IDMEUSERDATA_DATA_SUCCESS,
    GET_IDMEUSERDATA_DATA_ERROR, IDMEUSERDATA_END_LOADING, RESET_IDMEUSERDATA
} from "../actions/actionIDMeUserData";
import { loadState, saveState } from "../helpers/sessionStorage";

const sessionKey = "userdata";

const initialState = {
    userdata: loadState(sessionKey, {}),
    loading: false,
    userdataerror: ''
};


function reducerIDMeUserData(state = initialState, action) {

    switch (action.type) {
        case IDMEUSERDATA_LOADING: {
            return {
                ...state,
                loading: true,
                userdataerror: ''
            };
        }

        case GET_IDMEUSERDATA_DATA_SUCCESS: {

            saveState(sessionKey, action.payload);

            return {
                ...state,
                loading: false,
                userdata: action.payload,
                userdataerror: ''
            };
        }

        case GET_IDMEUSERDATA_DATA_ERROR: {

            saveState(sessionKey, action.payload);

            return {
                ...state,
                loading: false,
                userdata: {},
                userdataerror: action.error
            }
        }

        case IDMEUSERDATA_END_LOADING: {
            return {
                ...state,
                loading: false
            }
        }

        case RESET_IDMEUSERDATA: {

            saveState(sessionKey, {});

            return {
                ...state,
                userdata: {},
                loading: false,
                userdataerror: ''
            }
        }
        default: {
            return state;
        }
    }
}

export default reducerIDMeUserData;